export default __webpack_public_path__ + "static/media/muddyHead.952d7487.jpg";